



























// @ is an alias to /src
import { Vue, Component, Prop } from 'vue-property-decorator';


@Component({
  name: 'ShipmentForm',
})
export default class ShipmentForm extends Vue {
  @Prop({ default: "default label" })
  private label!: string;

  @Prop({ default: "" })
  private input!: string;

  @Prop({ default: () => null })
  private clickAction!: () => void;

  @Prop({ default: true })
  private clickable!: boolean;

  @Prop({ default: false })
  private enableNewline!: boolean;

  private executeClick() {
    if (this.clickable) {
      this.clickAction();
    }
  }

}
